module.exports = __webpack_public_path__ + "assets/img/left-submit-en.dab7a599.png";